export default __webpack_public_path__ + "static/media/layout_dark_v2_info_major_cogfunc.4e8b10f6.svg";